import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SiderMenuService {


  onRefresh$ = new Subject();
  constructor() {

  }

  refresh() {
    this.onRefresh$.next();
  }
}
